import { render, staticRenderFns } from "./ThreeDotsVerticalIcon.vue?vue&type=template&id=55161600&"
import script from "./ThreeDotsVerticalIcon.vue?vue&type=script&lang=js&"
export * from "./ThreeDotsVerticalIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports